"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockedMessageCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../utils/CardHelper");
const BlockedMessageCard = (survey, blockedReasonRecipients, appealConversationId) => {
    const card = CardHelper_1.CardHelper.newCard();
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    card.addItem(container);
    const title = `We were unable to send some of the messages for the ${(0, CardHelper_1.getSurveyTypeDisplay)(survey.type)}: ${survey.title}`;
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
        text: title,
        wrap: true,
    }));
    blockedReasonRecipients.forEach(blockedReasonRecipient => {
        if (blockedReasonRecipient.recipients.length <= 0) {
            return;
        }
        const messagesContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
            spacing: adaptivecards_1.Spacing.ExtraLarge,
            style: adaptivecards_1.ContainerStyle.Emphasis,
        });
        container.addItem(messagesContainer);
        messagesContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
            size: adaptivecards_1.TextSize.Medium,
            text: blockedReasonRecipient.header,
            weight: adaptivecards_1.TextWeight.Bolder,
            wrap: true,
        }));
        const recipientsText = blockedReasonRecipient.recipients.join(", ");
        messagesContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
            size: adaptivecards_1.TextSize.Default,
            text: recipientsText,
            wrap: true,
        }));
    });
    if (appealConversationId) {
        card.addAction((0, commands_1.SurveyDeepLinkAction)(survey.tenantId, survey.type, appealConversationId));
    }
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
};
exports.BlockedMessageCard = BlockedMessageCard;
//# sourceMappingURL=BlockedMessageCard.js.map